import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPubmedLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.47559 4.44336V25.7201C4.47559 25.7201 12.6554 24.7682 12.6554 32.7582V12.6224C12.6554 5.0135 4.47559 4.44336 4.47559 4.44336Z",
			fill: "#231F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.30664 2.94873V21.6702C8.30664 21.6702 12.8223 22.5415 12.8223 30.5307C12.8223 38.5207 12.845 15.6669 12.845 11.3865C12.8457 3.77829 8.30664 2.94873 8.30664 2.94873Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6665 12.5767V31.8518C12.6665 31.8518 16.6766 20.9018 33.5343 35.0091C33.5343 29.8967 33.5665 17.0026 33.5665 12.7408C16.9034 0.905973 12.6665 12.5767 12.6665 12.5767Z",
			fill: "#3978AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1865 26.818H17.8796L19.0728 18.6503H19.1106L22.3879 26.818H23.866L27.2942 18.6503H27.3319L28.3735 26.818H32.0887L29.9271 12.6313H26.234L23.1646 20.2132L20.2661 12.6313H16.6108L14.1865 26.818Z",
			fill: "white"
		})
	]
});
export default SvgPubmedLogo;
